export default __webpack_public_path__ + "static/media/activewear.06d6cfe9.svg";